<template>
  <el-form-item
    :label="label"
    class="irregular"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="irregular"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
      :filter-method="filter"
    >
      <el-option label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :value="item.value"
      >
        <span style="float: left; color: #8492a6; font-size: 13px">{{item.value}}</span>
        <span style="float: right;">{{item.label}}</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: 'イレギュラー状態'
    },
    prop: {
      type: String,
      default: 'irregular'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: []
    }
  },
  computed: {
    irregular: {
      get () {
        return this.value
      },
      set (irregular) {
        this.$emit('change', irregular)
        this.options = this.optionsOriginal
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    const irregular = await this.loadCode()
    const irregularSet = irregular.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })
    this.options = irregularSet
    this.optionsOriginal = irregularSet
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: 'IRREGULAR_TYPE' } })
          .then((res) => {
            sessionStorage.setItem('irregular', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('irregular'))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.irregular {
  ::v-deep .el-form-item__content {
    width: 12em;
  }
}
.el-select-dropdown__item span {
  padding-left: 5px;
  padding-right: 5px;
}
</style>
